import React, { useEffect, useState } from "react";
import Single_coin from "../../../../Images/coinn.png";

const UpcomingContests = () => {
  const contests = [
    { id: 1, prize: "₹30,000", joined: 300, title: "Daily GK Challenge" },
    { id: 2, prize: "₹20,000", joined: 180, title: "Maths Booster" },
    { id: 3, prize: "₹50,000", joined: 420, title: "SSC Special" },
    { id: 4, prize: "₹10,000", joined: 90, title: "Speed Test" },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % contests.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full mt-2 sm:mt-0 rounded-xl shadow-2xl bg-gradient-to-r from-[#F6F0FA] to-[#FFF] p-2">
      <h3 className="text-md font-bold text-slate-800 mb-2">
        Upcoming Contests
      </h3>

      {/* SLIDER WINDOW */}
      <div className="relative overflow-hidden h-28">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {contests.map((contest) => (
            <div key={contest.id} className="min-w-full px-2">
              <div className="flex items-stretch justify-between border rounded-xl bg-white overflow-hidden">

                {/* LEFT */}
                <div className="flex-1 p-2">
                  <div className="flex items-center justify-between mb-2">
                    <div>
                      <p className="text-sm text-slate-500">Prize Pool</p>
                      <p className="text-xl font-bold text-slate-900">
                        {contest.prize}
                      </p>
                    </div>

                    <div className="text-right">
                      <p className="text-xs text-green-600 font-semibold">
                        +20%
                      </p>
                      <p className="text-xs text-slate-500">
                        {contest.joined} joined
                      </p>
                    </div>
                  </div>

                  {/* Progress */}
                  <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
                    <div className="h-full w-[60%] bg-gradient-to-r from-[#FFB27A] to-[#FF782D]" />
                  </div>

                  {/* Info */}
                  <div className="flex items-center gap-6 sm:mt-2 text-sm font-semibold text-slate-600">
                    <span>📘 {contest.title}</span>
                    <span>⏱ Starts in 02:15:30</span>
                  </div>
                </div>

                {/* RIGHT */}
                <div className="w-32 flex flex-col justify-between py-5 bg-gradient-to-r from-[#6E4A7E] via-[#7F5C8F] to-[#8F6BA0] text-white font-semibold">
                  <div className="flex items-center justify-center">
                    <span className="text-[20px]">1000</span>
                    <img
                      src={Single_coin}
                      alt="coins"
                      className="w-4 ml-1"
                    />
                  </div>

                  <div className="mt-5 border-t text-[#f9a66a] p-2 text-center cursor-pointer">
                    Join Now
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>

      {/* DOTS */}
      <div className="flex justify-center gap-2 mt-3">
        {contests.map((_, index) => (
          <span
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              activeIndex === index
                ? "bg-purple-600 scale-125"
                : "bg-slate-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default UpcomingContests;
